import React, { useState } from "react";
import { Button } from "@/components/Button";
import { DrawerPageProps } from "../types";
import { Input } from "@/components/Input";
import {
  useApplyDiscountCode,
  useRemoveDiscountCode,
} from "../../AccountContext";
import { DiscountBadge } from "../../DiscountBadge";
import { cn } from "@/helpers/utils";

export interface EditDiscountPageProps extends DrawerPageProps {
  addressId: number;
  discountName?: string;
}

const EditDiscountPage = ({
  notify,
  onExit,
  discountName: activeDiscount,
  addressId,
}: EditDiscountPageProps) => {
  const [discountName, setDiscountName] = useState(activeDiscount);
  const removeDiscount = useRemoveDiscountCode();
  const applyDiscount = useApplyDiscountCode();
  const onRemove = (id: number) => {
    removeDiscount.mutate(id, {
      onSuccess: () => {
        notify({
          title: "Discount Removed",
          message: "Your discount code was removed.",
        });
      },
      onError: () => {
        notify({
          title: "Error",
          message: "There was an error removing your discount code.",
          severity: "error",
        });
      },
    });
  };
  const onApply = (data: { addressId: number; discountName: string }) => {
    applyDiscount.mutate(data, {
      onSuccess: () => {
        notify({
          title: "Discount Applied",
          message: `Discount code ${data.discountName.toLocaleUpperCase()} was applied`,
        });
      },
      onError: (error) => {
        let errorMessage =
          "Sorry, the discount code you entered has expired, been applied already, or is invalid.";

        // // Check if error is an instance of Error and contains a message
        // if (error instanceof Error && error.message) {
        //   const errorMessageMatch = error.message.match(/(\{.*\})/); // Match the JSON part
        //   if (errorMessageMatch) {
        //     try {
        //       const parsedError = JSON.parse(errorMessageMatch[1]); // Parse the matched JSON
        //       if (parsedError.error) {
        //         errorMessage = parsedError.error;
        //       }
        //     } catch (e) {
        //       // If parsing fails, retain the default error message
        //     }
        //   }
        // }

        notify({
          title: "Error",
          message: errorMessage,
          severity: "error",
        });
      },
    });
  };

  const handleApplyDiscountSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    onApply({ addressId, discountName: discountName || "" });
  };

  return (
    <>
      <form className="space-y-4" onSubmit={handleApplyDiscountSubmit}>
        <Input
          className="uppercase placeholder:normal-case"
          id="discount-input"
          label="Apply Discount"
          placeholder="Enter Discount Code"
          value={discountName}
          onChange={(event) => setDiscountName(event.target.value)}
        />
        <Button
          className="w-full"
          disabled={discountName === activeDiscount || !discountName}
          type="submit"
          onClick={handleApplyDiscountSubmit}
        >
          Apply Discount
        </Button>
        <p className="body text-sm">
          A single discount code can be applied to your next upcoming shipment.
          {activeDiscount
            ? " Remove the code below to add a different discount code."
            : ""}
        </p>
      </form>

      <div>
        <h6 className="subtitle w-full text-base font-semibold">
          Active Discount
        </h6>
        <DiscountBadge
          discountName={activeDiscount}
          onChange={
            activeDiscount
              ? () => {
                  onRemove(addressId);
                }
              : undefined
          }
          color="primary"
          className={cn("mt-4 w-full", activeDiscount && "font-semibold")}
        />
      </div>
    </>
  );
};

export { EditDiscountPage };
